export const URL = "https://east-eats-recipes.herokuapp.com/";